module.exports = __webpack_public_path__ + "static/media/thanks.1fc6b7de.gif";